import { PropsWithChildren } from "react";

export function IconContainer(props: PropsWithChildren) {
  return (
    <div className="bg-background border border-border rounded-lg flex items-center justify-center [&>svg]:size-4 size-9">
      {props.children}
    </div>
  );
}
